import styled from 'styled-components';
import { TransactionType } from 'types/enums';

export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitleContainer = styled.div`
  flex: 1;
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  color: #64748b;
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f1f5f9;
    color: #1e293b;
  }
`;

export const ModalContent = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  height: 100%;

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;

  @media (max-width: 600px) {
    padding: 12px 16px;
  }
`;

// Styles for UserBalanceTab
export const ContentGrid = styled.div`
  padding: 24px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  height: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const CardsSection = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const ChartSection = styled.div`
  flex: 2 1 60%;
  min-width: 300px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #f3f4f6;
  max-height: 400px;

  h3 {
    margin: 0 0 16px 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: #1f2937;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .chart-container {
    height: 300px;
  }
`;

export const TransactionContainer = styled.div`
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const TransactionHeader = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  align-items: center;
`;

export const SearchContainer = styled.div`
  position: relative;
  flex: 1;
  max-width: 400px;

  svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #3b4f8f;
    box-shadow: 0 0 0 3px rgba(59, 79, 143, 0.1);
  }
`;

export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: white;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #374151;
  transition: all 0.2s;

  &:hover {
    background-color: #f9fafb;
    border-color: #9ca3af;
  }
`;

export const ExportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: #3b4f8f;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  color: white;
  transition: all 0.2s;

  &:hover {
    background-color: #2d3a6b;
  }
`;

export const TransactionTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeader = styled.thead`
  background-color: #f9fafb;
`;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;
`;

export const TableCell = styled.td`
  padding: 12px;
  text-align: left;
  font-size: 14px;
  color: #374151;
`;

export const StatusBadge = styled.span<{ type: TransactionType }>`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;

  background-color: ${(props) =>
    props.type === TransactionType.DEBIT ? '#FEE2E2' : '#D1FAE5'};
  color: ${(props) =>
    props.type === TransactionType.DEBIT ? '#DC2626' : '#059669'};
`;

export const TransactionList = styled.div`
  flex: 1;
`;

export const TransactionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f9fafb;
  }
`;

export const TransactionInfo = styled.div`
  flex: 1;
`;

export const TransactionDescription = styled.div`
  font-size: 14px;
  color: #374151;
  margin-bottom: 4px;
`;

export const TransactionDate = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const TransactionAmount = styled.div<{
  type: TransactionType;
}>`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) =>
    props.type === TransactionType.DEBIT ? '#DC2626' : '#059669'};
`;

export const CreditContainer = styled.div`
  height: 100%;
  display: flex;
`;

export const CreditForm = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: 500px;
  max-width: 400px;
  gap: 16px;
`;
export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

export const CreditHistory = styled.div`
  flex: 2;
  padding: 24px 0 24px 24px;
  border-left: 1px solid #e5e7eb;
  overflow-y: auto;
`;

export const HistoryTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 24px 0;
`;

export const HistoryItem = styled.div`
  margin-right: 24px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 12px;
  transition: all 0.2s;

  &:hover {
    border-color: #3b4f8f;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    background-color: rgba(41, 55, 120, 0.05);
  }
`;

export const HistoryDescription = styled.div`
  font-size: 14px;
  color: #374151;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const HistoryDate = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

export const HistoryAmount = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #059669;
`;
